import AbstractModel, { Model } from './abstract-model';
import CavCavite from "./cav-cavite";
import BeanCoord from './bean-coord';

@Model('BeanQueryResult')
export default class BeanQueryResult<T=CavCavite> extends AbstractModel {
  public cavites: Partial<T>[] = null;
	public totalSize: number = 0;
}

